export const handleImageExtensionValidation = (fileName: string) => {
    const validExtensions = ['jpg','jpeg','png'];
    var fileExtension = fileName.split('.').pop();
    return validExtensions.includes(fileExtension!);
};
